import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import * as fileSaver from 'file-saver';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-issue-seller-posting-label-brief-component',
  templateUrl: './issue-seller-posting-label-brief-component.component.html',
  styleUrl: './issue-seller-posting-label-brief-component.component.scss'
})
export class IssueSellerPostingLabelBriefComponentComponent implements OnInit {
  FilteredgetSubDetailsData = [];

  labelsData = [];
  tempdata = [];
  data1 = [];
  today = new Date();
  repNames: string[] = [];
  deliveryMode = '';
  firstRepName = '';
  lastRepName = '';
  district = '';
  state = '';
  taluka = '';
  iscustomer: any;

  constructor(
    private datePipe: DatePipe,
    private dialogref: MatDialogRef<IssueSellerPostingLabelBriefComponentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  currentDate: Date = new Date();
  groupedData = [];
  country: any = null;
  sub_type: any = null;
  pincode: any = null;
  office_rep_name: any = null;
  rep_name: any = null;
  name: any = null;
  delivery_mode: any = null;

  ngOnInit(): void {
    this.FilteredgetSubDetailsData = [];
    this.labelsData = this.data['addresslabels'];

    // ✅ Corrected repNames parsing
    const repNameStr = this.data['rep_names'];
    this.repNames = (repNameStr || '').split(',').map(x => x.trim());

    if (this.repNames.length > 0) {
      this.firstRepName = this.repNames[0] === 'all' ? this.repNames[1] : this.repNames[0];
      this.lastRepName = this.repNames[this.repNames.length - 1];
    }

    this.district = this.data['district_name'];
    this.country = this.data['country'];
    this.state = this.data['state_name'];
    this.taluka = this.data['taluka_name'];
    this.iscustomer = this.data['iscustomer'];
    this.sub_type = this.data['sub_type'];
    this.pincode = this.data['pincode'];
    this.office_rep_name = this.data['office_rep_name'];
    this.rep_name = this.data['rep_name'];
    this.name = this.data['name'];
    this.delivery_mode = this.data['delivery_mode'];

    this.tempdata = this.uniqueid(this.labelsData, (a) => a['district']);

    this.sortDataDistrictwise();
    this.groupDataBySubscription();
  }

  groupDataBySubscription() {
    this.groupedData = this.data1.reduce((acc, item) => {
      let group = acc.find(g =>
        (!this.country || this.country.includes(g.country)) &&
        (!this.state || this.state.includes(g.state)) &&
        (!this.district || this.district.includes(g.district)) &&
        (!this.taluka || this.taluka.includes(g.taluka)) &&
        (!this.sub_type || this.taluka.includes(g.sub_type)) &&
        (!this.pincode || this.pincode.includes(g.pincode)) &&
        (!this.office_rep_name || this.office_rep_name.includes(g.office_rep_name)) &&
        (!this.rep_name || this.rep_name.includes(g.rep_name)) &&
        (!this.name || this.name.includes(g.name)) &&
        (!this.delivery_mode || this.delivery_mode.includes(g.delivery_mode))
      );

      if (!group) {
        group = {
          country: item.country || null,
          state: item.state || null,
          delivery_mode: item.delivery_mode || null,
          district: item.district,
          taluka: item.taluka || null,
          office_rep_name: item.office_rep_name || null,
          rep_name: item.rep_name || null,
          name: item.name || null,
          pincode: item.pincode || null,
          items: []
        };
        acc.push(group);
      }

      group.items.push(item);
      return acc;
    }, []);
  }

  sortDataDistrictwise() {
    this.labelsData.sort((a, b) => Number(a.pincode) - Number(b.pincode));
    for (let index = 0; index < Object.keys(this.tempdata).length; index++) {
      let data = this.labelsData.filter(
        (a) => a['district'] === this.tempdata[index]['district']
      );
      this.data1.push(data);
    }

    let flattenedData = [];
    this.data1.forEach(element => {
      element.forEach(data2 => {
        flattenedData.push(data2);
      });
    });
    this.data1 = flattenedData;

    if (this.data1.length <= 4) {
      const requiredLength = 5;
      const numberOfItemsToAdd = requiredLength - this.data1.length;

      for (let i = 0; i < numberOfItemsToAdd; i++) {
        this.data1.push({
          shortname: '',
          month: '',
          subno: '',
          year: '',
          title: '',
          name: '',
          address: '',
          taluka: '',
          district: '',
          pincode: '',
          state: ''
        });
      }
    }
  }

  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }

  getPageNumber(index: number): number {
    return Math.floor(index / 28) + 1;
  }

  show = false;
  printPage() {
    this.show = true;
    const printContent = document.getElementById('print-section')?.outerHTML;
    if (!printContent) {
      console.error("Print section not found!");
      return;
    }

    const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');
    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Report</title>
            <style>
              @media print {
                @page { size: A3 landscape; margin: 5mm; }
                body { font-family: Arial, sans-serif; font-size: 16px; margin: 0; padding: 5mm; line-height: 1.2; }
                table { width: 100%; height: 100%; border-collapse: collapse; table-layout: fixed; page-break-inside: avoid; }
                th, td { padding: 1px; border: 1px solid black; text-align: left; font-size: 14px; line-height: 1.2; }
                .noPrint { display: none; }
              }
            </style>
          </head>
          <body>
            <div id="print-section1">${printContent}</div>
            <script>
              window.onload = function() { 
                window.print(); 
                setTimeout(() => { window.close(); }, 500);
              };
            </script>
          </body>
        </html>
      `);
      printWindow.document.close();
    } else {
      console.error("Failed to open print window.");
    }
  }

  formatDateRange(row: any): string {
    const entryDate = row.entry_date ? this.datePipe.transform(row.entry_date, 'dd/MM/yyyy') : '';
    const subPeridToDate = row.sub_perid_to_date ? this.datePipe.transform(row.sub_perid_to_date, 'dd/MM/yyyy') : '';
    return `${entryDate} - ${subPeridToDate}`;
  }

  group: {
    rep_name?: string;
    office_rep_name?: string;
    delivery_mode?: string;
    country?: string;
    state?: string;
    district?: string;
    taluka?: string;
    Subscription_Type?: string;
  } = {};

  excelToExportPostingLabel(name: string) {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';

    if (!this.data1 || this.data1.length === 0) {
      console.warn('No data available to export.');
      return;
    }

    const limitedData = this.data1.map(row => ({
      "वर्गणीदार क्रमांक": `${row.month || ''}/${row.subno || ''}`,
      "वर्गणीदार नाव": `${row.name || ''}`,
      "पत्ता": `${row.address || ''} ${row.taluka || ''} ${row.district || ''} ${row.state || ''} ${row.country || ''} ${row.pincode || ''}`,
      "वर्गणीदार प्रकार": row.Subscription_Type || '',
      "वैध दिनांक": `${row.entry_date ? this.datePipe.transform(row.entry_date, 'dd/MM/yyyy') : ''} - ${row.sub_perid_to_date ? this.datePipe.transform(row.sub_perid_to_date, 'dd/MM/yyyy') : ''}`,
      "संपर्क": row.mobileNumber || ''
    }));

    let worksheet = {};
    const headerRows1 = [
      [`दिनांक: ${this.datePipe.transform(new Date(), 'dd/MM/yyyy')}`, 'हिंदुस्तान प्रकाशन संस्था विवेक साप्ताहिक', '', '', '', ''],
    ];
    XLSX.utils.sheet_add_aoa(worksheet, headerRows1, { origin: "A1" });

    const headerRows2 = [
      [`पृष्ठ क्र:  `, '', 'नोंदणीदार - प्रतिनिधी व कार्यालयीन वर्गणी वर्गणी जमा असलेले', '', '', ''],
    ];
    XLSX.utils.sheet_add_aoa(worksheet, headerRows2, { origin: "A2" });

    const headerRows3 = [
      [` `, 'वितरण - टपाल ', 'वर्गणी - वर्गणी जमा असलेले ', 'वितरण सांकेताकानुसार वर्गणीदार यादीर्गणीदार प्रकार ', '', '']
    ];
    XLSX.utils.sheet_add_aoa(worksheet, headerRows3, { origin: "A4" });

    const columnHeaders = [["वर्गणीदार क्रमांक", "वर्गणीदार नाव", "पत्ता", "वर्गणीदार प्रकार", "वैध दिनांक", "संपर्क"]];
    XLSX.utils.sheet_add_aoa(worksheet, columnHeaders, { origin: "A5" });

    XLSX.utils.sheet_add_json(worksheet, limitedData, { skipHeader: true, origin: "A6" });

    const workbook = {
      Sheets: { dataSheet: worksheet },
      SheetNames: ['dataSheet'],
    };

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blobData = new Blob([excelBuffer], { type: EXCEL_TYPE });
    fileSaver.saveAs(blobData, `${name}${EXCEL_EXTENSION}`);
  }
}
